import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  email: '',
  password: '',
  phone: '',
  accessToken: '',
  company: {
    id: '',
    companyName: '',
    email: '',
    placeId: '',
    address: '',
    phone: '',
    website: '',
    dunsNumber: '',
    link: '',
    pictures: '',
    isValidate: false,
    description: ''
  }
};

export const businessSlice = createSlice({
  name: 'business',
  initialState,
  reducers: {
    addSignUpData: (state, action) => {
      return { ...state, ...action.payload };
    },
    clearForm: () => {
      return initialState;
    }
  }
});

export const { addSignUpData, clearForm } =
  businessSlice.actions;

export default businessSlice.reducer;
